import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { Grid, Row, Col, Button } from 'react-bootstrap';

class CmsBlankPage extends React.Component {
  render() {
    const { intl } = this.props;
    const messages = intl.messages;

    return (
      <div class="jumbotron">
        <Grid fluid class="m-b-20 m-t-20">
          <Row>
            <Col lg={6} class="bg-white">
              <div class="padding-30 text-center">Nice video here</div>
            </Col>
            <Col lg={6}>
              <div class="card card-transparent">
                <div class="card-header">
                  <div class="card-title">{messages.cms_content}</div>
                </div>
                <div class="card-block">
                  <h3>{messages.start_editing}</h3>
                  <p>{messages.this_is_blank_page_use_editor_to_create_great_one}</p>
                  <div class="text-right p-t-15">
                    <Button bsStyle="primary" onClick={this.props.action}>
                      <i class="fa fa-plus m-r-10" /> {messages.cms_add_container}
                    </Button>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}
CmsBlankPage.propTypes = {
  action: PropTypes.func.isRequired,
};

export default withRouter(injectIntl(CmsBlankPage));
